import { render, staticRenderFns } from "./Risque.vue?vue&type=template&id=79576ea2&scoped=true&"
import script from "./Risque.vue?vue&type=script&lang=js&"
export * from "./Risque.vue?vue&type=script&lang=js&"
import style0 from "./Risque.vue?vue&type=style&index=0&id=79576ea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79576ea2",
  null
  
)

export default component.exports